// Copresent has ONE privacy policy and one set of terms, both on the website.
// The clicker links to them; it never hosts its own copy. Canonical URLs, so a
// click doesn't bounce through the apex → www redirect.
export const PRIVACY_POLICY_URL = "https://www.copresent.app/privacy/";
export const TERMS_URL = "https://www.copresent.app/terms/";

// The clicker used to serve its own policy here, and the Chrome Web Store
// listing and old links still point at it. Firebase Hosting 301s it to the
// website (firebase.json); this path is the fallback for anything that serves
// the SPA without those rules (the dev server).
export const LEGACY_PRIVACY_PATH = "/privacy-policy";
